export function getClientFilesBucket() {
  const envLabel = process.env.REACT_APP_ENV_LABEL || 'dev';
  const bucketBase = process.env.REACT_APP_CLIENT_FILES_BUCKET || 'initio-client-files';
  if (bucketBase.endsWith(`-${envLabel}`)) {
    return bucketBase;
  }
  return `${bucketBase}-${envLabel}`;
}

export function parseS3UriLocation(location, prefix) {
  if (!location || typeof location !== 'string' || !location.startsWith('s3://')) {
    return null;
  }
  const withoutScheme = location.replace('s3://', '');
  const firstSlash = withoutScheme.indexOf('/');
  if (firstSlash < 0) return null;
  const bucket = withoutScheme.slice(0, firstSlash);
  const fullKey = withoutScheme.slice(firstSlash + 1);
  const rawKey = prefix && fullKey.startsWith(prefix) ? fullKey.slice(prefix.length) : fullKey;
  const key = rawKey.startsWith('/') ? rawKey : `/${rawKey}`;
  return { bucket, key };
}
